import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const EmptyTextContainer = styled.div`
  width: 100%;
  height: 296px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  text-align: center;
  line-height: 1.22;
  color: #354354;
`;

export default class EmptyText extends Component {
  render() {
    const { text } = this.props;

    return <EmptyTextContainer>{text}</EmptyTextContainer>;
  }
}

EmptyText.propTypes = {
  text: PropTypes.string,
};

EmptyText.defaultProps = {
  text: {},
};
